import React, { useContext  } from "react";
import { AuthContext } from "../store/AuthContext";
import { Link } from "react-router-dom";

import "react-toastify/dist/ReactToastify.min.css";

const ChoiceScreen = () => {
  const { handleLogout, timer } = useContext(AuthContext);

  if (timer === 0) {
    handleLogout();
  }
  if (timer < 3) {
    return (
      <>
        <p className="text-white">
          Em {timer} segundos, você será desconectado automaticamente...
        </p>
      </>
    );
  }

  return (
    <>
      <div className="container">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-lg">
                <div className="p-5">
                  <div className="text-center">
                    <p>Selecione sua categoria</p>
                    <br />
                  </div>

                  {/* formulario de cadastro  */}

                  <form className="user">
                    <div className="form-group row">
                      <div className="col-sm-5 mb-3 mb-sm-0">
                        <Link className="nav-link" to={"/formTC"}>
                          <img
                            src="img/choise_plena.png"
                            className="img-fluid"
                            alt="Credencial Plena"
                          />
                        </Link>
                      </div>
                      <div className="col-sm-2"></div>
                      <div className="col-sm-5">
                       {/*
                        <Link className="nav-link" to={"/formPG"}>
                          <img
                            src="img/choise_PG.png"
                            className="img-fluid"
                            alt="Credencial Público Geral "
                          />
                        </Link>

                        */}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChoiceScreen;
